<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="regionForm" refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                regionForm: () => import('../forms/RegionForm'),
                headers: [
                    { text: 'Name', value: 'name' },
                    { text: 'Region Type', value: 'regionTypeId', table: 'regionTypes', form: () => import('../forms/RegionTypeForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    regionTypes: [],
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                    { column: "regionTypeId", direction: "ascending" },
                ],
                itemsField: 'regions',
                editPageName: 'region',
                apiMethod: 'Regions',
                claimName: 'Regions',
                formTitle: 'Region',
                excelTitle: 'Regions',
                hasEditPage: false,
            }
        },
    };
</script>
